import type { Currency } from "~/types/Finance";

export const useCurrencySwitcher = () => {
  const platformStore = usePlatformStore();
  const platformConfiguration = ref(platformStore.getPlatformConfiguration);

  // currency related logic
  const { activeCurrency, setActiveCurrency } = useActiveCurrency();
  const availableCurrencies = computed(() =>
    platformConfiguration.value.properties.availableCurrencies?.filter(
      (c) => c.isoCurrencyCode !== activeCurrency.value.isoCurrencyCode,
    ),
  );

  const setCurrency = (currency: Currency) => {
    setActiveCurrency(currency.isoCurrencyCode);
    showCurrencies(false);
  };

  // display related logic
  const areCurrenciesShown = ref(false);
  const showCurrencies = (show: boolean) => {
    areCurrenciesShown.value = show;
  };

  const hideCurrencies = () => {
    areCurrenciesShown.value = false;
  };

  const toggleCurrencies = () => {
    areCurrenciesShown.value = !areCurrenciesShown.value;
  };

  return {
    activeCurrency,
    availableCurrencies,
    setCurrency,
    areCurrenciesShown,
    showCurrencies,
    hideCurrencies,
    toggleCurrencies,
  };
};
